<div class="cliente-cadastro-situacao-card-chart {{cadastroClass}} {{situacaoClass}}">
    <div class="cliente-cadastro-situacao-card-chart-header">
        {{nome}}
    </div>
    <div class="cliente-cadastro-situacao-card-chart-body">
        <h4 class="cliente-cadastro-situacao-card-title">
            {{quantidadeClientes | decimalFormat:1:0:0}}
            <small class="cliente-cadastro-situacao-card-subtitle">
                ({{percParticipacao | decimalFormat:1:2:2}}%)
            </small>
        </h4>
    </div> 
</div>